/* Hanukkiah builder (three.js r147) */
(() => {
  const root = document.getElementById('hkb');
  if (!root) return;
  const MODELS = JSON.parse(root.querySelector('[data-models]').textContent);
  const VARIANT_ID = Number(root.dataset.variant);
  const TEXTURES = [
    { id: 1, name: 'Object 01', desc: 'Ribbed orbs' },
    { id: 2, name: 'Object 02', desc: 'Bubbles' },
    { id: 3, name: 'Object 03', desc: 'Fluted column' },
    { id: 4, name: 'Object 04', desc: 'Spiral' },
    { id: 5, name: 'Object 05', desc: 'Pyramid studs' },
    { id: 6, name: 'Object 06', desc: 'Faceted' }
  ];
  // Bambu Lab filament colors, measured from daylight photos of all ten printed side by side on white paper
  const COLORS = [
    { name: 'Bone White', hex: '#CDC8C0', rough: .85 },
    { name: 'White', hex: '#EBEAE8', rough: .85 },
    { name: 'Beige', hex: '#A88C66', rough: .85 },
    { name: 'Pale Pink', hex: '#E6CDBD', rough: .7 },
    { name: 'Gray', hex: '#7E7F7F', rough: .7 },
    { name: 'Green', hex: '#35401C', rough: .72 },
    { name: 'Navy Blue', hex: '#0D1F4A', rough: .68 },
    { name: 'Brown', hex: '#462E1F', rough: .68 },
    { name: 'Black', hex: '#111111', rough: .62 },
    { name: 'Terracotta', hex: '#B84E2A', rough: .85 }
  ];
  const SLOT_NAMES = Array.from({ length: 9 }, (_, i) => i);
  const state = {
    sham: 0,
    tex: [2, 2, 2, 2, 2, 2, 2, 2, 2],
    col: Array(9).fill(0),
    base: 1,
    selected: new Set([0, 1, 2, 3, 4, 5, 6, 7, 8]),
    night: 0,
    evening: false,
    cups: false
  };

  // preset listings link here as ?design=1..6|mix&color=Terracotta
  const params = new URLSearchParams(location.search);
  const presetDesign = params.get('design');
  const presetColor = COLORS.findIndex((c) => c.name.toLowerCase() === (params.get('color') || '').toLowerCase());
  if (/^[1-6]$/.test(presetDesign || '')) state.tex = Array(9).fill(Number(presetDesign));
  if (presetDesign === 'mix') { const order = [1, 2, 3, 4, 5, 6, 1, 2]; let k = 0; state.tex = state.tex.map((_, i) => (i === state.sham ? 4 : order[k++])); }
  if (presetColor >= 0) { state.col = Array(9).fill(presetColor); state.base = presetColor; }
  if ((params.get('color') || '').toLowerCase() === 'multicolor') {
    // the multicolor photo: one color per holder, left to right, on a Bone White base
    const names = ['White', 'Beige', 'Pale Pink', 'Navy Blue', 'Gray', 'Brown', 'Green', 'Bone White', 'Terracotta'];
    state.col = names.map((n) => COLORS.findIndex((c) => c.name === n));
    state.base = COLORS.findIndex((c) => c.name === 'Bone White');
  }

  /* ---------- 3D scene (units: millimetres) ---------- */
  const stage = document.getElementById('stage');
  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;
  // linear tone mapping keeps filament hues true (ACES pushed terracotta toward orange)
  renderer.toneMapping = THREE.LinearToneMapping;
  renderer.toneMappingExposure = 0.45;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  stage.prepend(renderer.domElement);
  let host = stage; // the canvas moves into the floating mini preview on phones

  const scene = new THREE.Scene();
  const pmrem = new THREE.PMREMGenerator(renderer);
  const envTex = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
  scene.environment = envTex;

  const camera = new THREE.PerspectiveCamera(30, 4 / 3, 5, 5000);
  camera.position.set(-20, 110, 520);
  const controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.target.set(0, 40, 0);
  controls.enableDamping = true;
  controls.enablePan = false;
  controls.minDistance = 220; controls.maxDistance = 1200;
  controls.minPolarAngle = Math.PI * 0.2; controls.maxPolarAngle = Math.PI * 0.52;
  controls.minAzimuthAngle = -Math.PI * 0.42; controls.maxAzimuthAngle = Math.PI * 0.42;

  const key = new THREE.DirectionalLight(0xfff8f0, 0.7);
  key.position.set(-220, 380, 420); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  Object.assign(key.shadow.camera, { left: -260, right: 260, top: 200, bottom: -120, near: 10, far: 1500 });
  key.shadow.radius = 14; key.shadow.bias = -0.0004;
  scene.add(key);
  const hemi = new THREE.HemisphereLight(0xffffff, 0xb9b2aa, 0.35);
  scene.add(hemi);
  // soft fill from the front right, like room light in the product photo
  const fill = new THREE.DirectionalLight(0xffffff, 0.2);
  fill.position.set(300, 120, 400); scene.add(fill);

  // tabletop + wall that catch soft shadows
  const groundMat = new THREE.ShadowMaterial({ opacity: 0.22 });
  const ground = new THREE.Mesh(new THREE.PlaneGeometry(4000, 4000), groundMat);
  ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

  // measured from the MENORAH BASE file: 299.5 x 50 x 10 mm, sockets 31.25 mm apart, 6.5 mm deep
  const SPACING = 31.25, SOCKET_Z = 1.48;
  const xs = SLOT_NAMES.map((i) => (i - 4) * SPACING);
  const BASE_H = 10, BASE_L = 299.5;
  const SCREW = 6, RECESS = 12.5; // holder screw length and cup recess depth
  const isSham = (i) => i === state.sham;
  // night number of a holder: candles are added right to left, so the rightmost regular holder is night 1
  function nightNo(i) {
    if (isSham(i)) return 0;
    let n = 0;
    for (let j = 8; j >= i; j--) if (!isSham(j)) n++;
    return n;
  }
  const label = (i) => (isSham(i) ? 'Shamash' : `Night ${nightNo(i)}`);

  // fine horizontal print layers, added to the standard material's shading
  function plaMaterial(c) {
    // print lines read strongly on dark filament and almost vanish on white (light scatters inside pale plastic)
    const lum = new THREE.Color(c.hex).getHSL({}).l;
    const layerAmp = (0.22 - 0.16 * lum).toFixed(3);
    const m = new THREE.MeshPhysicalMaterial({ color: new THREE.Color(c.hex).convertSRGBToLinear(), vertexColors: true, roughness: c.rough, metalness: 0, sheen: 0.12, sheenRoughness: 0.9, sheenColor: new THREE.Color(0xffffff), envMapIntensity: 1.0 });
    // print layer lines on the sides only; flat faces (holder tops, base top) get the fine grain of the textured build plate instead
    m.onBeforeCompile = (sh) => {
      sh.vertexShader = sh.vertexShader.replace('#include <common>', '#include <common>\nvarying vec3 vWorldP;\nvarying float vFlat;')
        .replace('#include <worldpos_vertex>', '#include <worldpos_vertex>\nvWorldP = (modelMatrix * vec4(transformed, 1.0)).xyz;\nvFlat = abs(normalize(mat3(modelMatrix) * objectNormal).y);');
      sh.fragmentShader = sh.fragmentShader.replace('#include <common>', '#include <common>\nvarying vec3 vWorldP;\nvarying float vFlat;\nfloat grain(vec2 p) { return fract(sin(dot(floor(p), vec2(12.9898, 78.233))) * 43758.5453); }\nfloat vnoise(vec2 p) { vec2 i = floor(p), f = fract(p); f = f * f * (3.0 - 2.0 * f); return mix(mix(grain(i), grain(i + vec2(1.0, 0.0)), f.x), mix(grain(i + vec2(0.0, 1.0)), grain(i + vec2(1.0)), f.x), f.y); }')
        .replace('#include <color_fragment>', '#include <color_fragment>\nfloat flatMask = smoothstep(0.92, 0.99, vFlat);\ndiffuseColor.rgb *= 1.0 + (grain(vWorldP.xz * 6.0) - 0.5) * 0.06 * flatMask;')
        .replace('#include <normal_fragment_maps>', `#include <normal_fragment_maps>\nfloat sideMask = 1.0 - smoothstep(0.6, 0.9, vFlat);\nfloat fw = fwidth(vWorldP.y) * 5.0;\nfloat layer = sin(vWorldP.y * 31.4159) * clamp(1.0 - fw, 0.0, 1.0) * sideMask;\nfloat fMask = smoothstep(0.92, 0.99, vFlat) * clamp(1.0 - fwidth(vWorldP.x) * 3.0, 0.0, 1.0);\nvec2 pe = vec2(vnoise(vWorldP.xz * 5.0), vnoise(vWorldP.zx * 5.0 + 7.0)) - 0.5;\nnormal = normalize(normal + (viewMatrix * vec4(pe.x * 0.45 * fMask, layer * ${layerAmp}, pe.y * 0.45 * fMask, 0.0)).xyz);`);
    };
    m.customProgramCacheKey = () => `pla-${layerAmp}`; // one compiled shader per line strength
    return m;
  }
  const matCache = new Map();
  const mat = (ci) => { if (!matCache.has(ci)) matCache.set(ci, plaMaterial(COLORS[ci])); return matCache.get(ci); };

  const base = new THREE.Mesh(new THREE.BufferGeometry(), mat(0));
  base.castShadow = true; base.receiveShadow = true; scene.add(base);

  // glass oil cup with oil, wick and flame
  // tapered foot drops into the 11 mm hole in the holder top; the bowl sits above it
  const cupProfile = [[0, -8], [4.6, -8], [5.2, -7.4], [5.3, -0.5], [9, 3], [12.5, 8], [13, 24], [13.4, 24.4], [13, 24.6], [12, 8.5], [8.4, 3.6], [4.2, -6.8], [0, -6.8]].map(([x, y]) => new THREE.Vector2(x, y));
  const cupGeo = new THREE.LatheGeometry(cupProfile, 48);
  const glassMat = new THREE.MeshPhysicalMaterial({ color: 0xffffff, roughness: 0.05, transmission: 0.95, thickness: 1.2, ior: 1.5, transparent: true, opacity: 0.55 });
  const oilGeo = new THREE.LatheGeometry([[0, -6.7], [4.1, -6.7], [8.3, 3.7], [11.9, 8.6], [12, 19], [0, 19]].map(([x, y]) => new THREE.Vector2(x, y)), 40);
  const oilMat = new THREE.MeshPhysicalMaterial({ color: 0xF2D46B, roughness: 0.35, transmission: 0.35, transparent: true, opacity: 0.92 });
  const wickHolderGeo = new THREE.CylinderGeometry(1.6, 1.6, 9, 16);
  const metalMat = new THREE.MeshStandardMaterial({ color: 0xcfd2d6, metalness: 0.9, roughness: 0.3 });
  const wickGeo = new THREE.CylinderGeometry(0.7, 0.7, 4, 8);
  const wickMat = new THREE.MeshStandardMaterial({ color: 0xf3efe6, roughness: 1 });
  const flameTex = (() => {
    const c = document.createElement('canvas'); c.width = 64; c.height = 128;
    const g = c.getContext('2d');
    const grd = g.createRadialGradient(32, 92, 2, 32, 80, 60);
    grd.addColorStop(0, 'rgba(255,255,235,1)'); grd.addColorStop(0.25, 'rgba(255,214,120,.95)');
    grd.addColorStop(0.6, 'rgba(255,140,40,.45)'); grd.addColorStop(1, 'rgba(255,120,30,0)');
    g.fillStyle = grd; g.beginPath(); g.ellipse(32, 72, 22, 54, 0, 0, Math.PI * 2); g.fill();
    const t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; return t;
  })();
  const flameMat = new THREE.SpriteMaterial({ map: flameTex, blending: THREE.AdditiveBlending, depthWrite: false, transparent: true });

  const holders = [];
  const loader = new THREE.GLTFLoader();
  const geoCache = new Map();
  // smooth normals only across soft curves; edges sharper than `deg` stay crisp (flat tops, the base's angled edge)
  function creaseNormals(src, deg) {
    const geo = src.index ? src.toNonIndexed() : src;
    const pos = geo.attributes.position, n = pos.count, cos = Math.cos(THREE.MathUtils.degToRad(deg));
    const fn = new Float32Array(n), a = new THREE.Vector3(), b = new THREE.Vector3(), c = new THREE.Vector3();
    const faceN = new Float32Array(n * 3);
    for (let i = 0; i < n; i += 3) {
      a.fromBufferAttribute(pos, i); b.fromBufferAttribute(pos, i + 1); c.fromBufferAttribute(pos, i + 2);
      c.sub(b); a.sub(b); c.cross(a).normalize();
      for (let k = 0; k < 3; k++) faceN.set([c.x, c.y, c.z], (i + k) * 3);
    }
    const key = (i) => `${Math.round(pos.getX(i) * 100)},${Math.round(pos.getY(i) * 100)},${Math.round(pos.getZ(i) * 100)}`;
    const groups = new Map();
    for (let i = 0; i < n; i++) { const k = key(i); if (!groups.has(k)) groups.set(k, []); groups.get(k).push(i); }
    const out = new Float32Array(n * 3);
    for (const ids of groups.values()) {
      for (const i of ids) {
        let x = 0, y = 0, z = 0;
        const fx = faceN[i * 3], fy = faceN[i * 3 + 1], fz = faceN[i * 3 + 2];
        for (const j of ids) {
          const gx = faceN[j * 3], gy = faceN[j * 3 + 1], gz = faceN[j * 3 + 2];
          if (fx * gx + fy * gy + fz * gz >= cos) { x += gx; y += gy; z += gz; }
        }
        const l = Math.hypot(x, y, z) || 1;
        out[i * 3] = x / l; out[i * 3 + 1] = y / l; out[i * 3 + 2] = z / l;
      }
    }
    geo.setAttribute('normal', new THREE.BufferAttribute(out, 3));
    // holder models carry baked ambient occlusion as vertex colors; anything without it renders unshaded
    if (!geo.attributes.color) geo.setAttribute('color', new THREE.BufferAttribute(new Float32Array(n * 3).fill(1), 3));
    return geo;
  }
  function getGeo(k) {
    if (!geoCache.has(k)) {
      // models ship as base64 text: decode, then parse the GLB
      geoCache.set(k, fetch(MODELS[k]).then((r) => { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); })
        .then((buf) => new Promise((res, rej) => {
          loader.parse(buf, '', (g) => {
            let geo = null;
            g.scene.traverse((o) => { if (o.isMesh && !geo) geo = o.geometry; });
            res(creaseNormals(geo, 40));
          }, rej);
        })));
    }
    return geoCache.get(k);
  }

  for (let i = 0; i < 9; i++) {
    const g = new THREE.Group();
    g.position.set(xs[i], BASE_H - SCREW, SOCKET_Z);
    const mesh = new THREE.Mesh(new THREE.BufferGeometry(), mat(state.col[i]));
    mesh.castShadow = true; mesh.receiveShadow = true; mesh.userData.slot = i;
    g.add(mesh);
    const cup = new THREE.Group();
    const glass = new THREE.Mesh(cupGeo, glassMat);
    const oil = new THREE.Mesh(oilGeo, oilMat);
    const holder = new THREE.Mesh(wickHolderGeo, metalMat); holder.position.y = 15;
    const wick = new THREE.Mesh(wickGeo, wickMat); wick.position.y = 21.5;
    const flame = new THREE.Sprite(flameMat); flame.scale.set(9, 20, 1); flame.position.y = 31; flame.visible = false;
    const light = new THREE.PointLight(0xffa64d, 0, 260, 2); light.position.y = 32;
    cup.add(glass, oil, holder, wick, flame, light);
    g.add(cup);
    scene.add(g);
    holders.push({ group: g, mesh, cup, flame, light, height: 0 });
  }

  const ring = new THREE.Mesh(new THREE.RingGeometry(15.4, 16.6, 48), new THREE.MeshBasicMaterial({ color: 0x5A1209, transparent: true, opacity: 0.85 }));
  ring.rotation.x = -Math.PI / 2;

  async function applyTexture(i) {
    const sham = isSham(i), tex = state.tex[i];
    const geo = await getGeo(`o${tex}_${sham ? 'sham' : 'reg'}`);
    if (sham !== isSham(i) || tex !== state.tex[i]) return; // changed while loading
    const h = holders[i];
    h.mesh.geometry = geo;
    h.height = sham ? 86 : 68.5;
    h.cup.position.y = h.height; // cup rests on the flat top over the centre hole
  }
  function applyColors() {
    holders.forEach((h, i) => { h.mesh.material = mat(state.col[i]); });
    base.material = mat(state.base);
  }
  function applySelectionMarkers() {
    holders.forEach((h, i) => {
      const old = h.group.getObjectByName('sel');
      if (old) h.group.remove(old);
      if (state.selected.has(i) && state.selected.size < 9) {
        const r = ring.clone(); r.name = 'sel'; r.position.y = SCREW + 0.3; h.group.add(r);
      }
    });
  }
  function applyLights() {
    stage.classList.toggle('night', state.evening);
    document.getElementById('mini')?.classList.toggle('night', state.evening);
    key.intensity = state.evening ? 0.06 : 0.7;
    fill.intensity = state.evening ? 0.01 : 0.2;
    hemi.intensity = state.evening ? 0.03 : 0.35;
    scene.environment = state.evening ? null : envTex;
    // nightly order: the shamash plus the N holders on the right (added right to left)
    holders.forEach((h, i) => {
      const lit = state.night > 0 && (isSham(i) || nightNo(i) <= state.night);
      h.flame.visible = lit;
      h.cup.visible = state.cups || lit;
      h.light.intensity = lit ? (state.evening ? 1.1 : 0.4) : 0;
    });
    groundMat.opacity = state.evening ? 0.35 : 0.22;
  }

  function resize() {
    const r = host.getBoundingClientRect();
    if (!r.width || !r.height) return; // hidden behind the photo gallery
    renderer.setSize(r.width, r.height, false);
    camera.aspect = r.width / r.height;
    const vfov = THREE.MathUtils.degToRad(camera.fov);
    const hfov = 2 * Math.atan(Math.tan(vfov / 2) * camera.aspect);
    const fit = Math.max((BASE_L / 2 + 20) / Math.tan(hfov / 2), 110 / Math.tan(vfov / 2));
    controls.maxDistance = fit * 1.6;
    camera.position.sub(controls.target).setLength(fit * 1.08).add(controls.target);
    camera.updateProjectionMatrix();
  }
  new ResizeObserver(resize).observe(stage);

  const ray = new THREE.Raycaster();
  let down = null;
  renderer.domElement.addEventListener('pointerdown', (e) => { down = [e.clientX, e.clientY]; });
  renderer.domElement.addEventListener('pointerup', (e) => {
    if (!down || Math.hypot(e.clientX - down[0], e.clientY - down[1]) > 6) return;
    const r = renderer.domElement.getBoundingClientRect();
    ray.setFromCamera({ x: ((e.clientX - r.left) / r.width) * 2 - 1, y: -((e.clientY - r.top) / r.height) * 2 + 1 }, camera);
    const hit = ray.intersectObjects(holders.map((h) => h.mesh))[0];
    if (hit) {
      const i = hit.object.userData.slot;
      if (e.shiftKey || e.metaKey || e.ctrlKey) toggleSlot(i); else selectOnly([i]);
    }
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clock = new THREE.Clock();
  renderer.setAnimationLoop(() => {
    const t = clock.getElapsedTime();
    holders.forEach((h, i) => {
      if (!h.flame.visible || reduceMotion) return;
      const f = 1 + Math.sin(t * 9 + i * 1.7) * 0.05 + Math.sin(t * 23 + i) * 0.03;
      h.flame.scale.set(9 * (2 - f), 20 * f, 1);
      h.light.intensity = (state.evening ? 1.1 : 0.4) * f;
    });
    controls.update();
    renderer.render(scene, camera);
  });

  /* ---------- controls ---------- */
  const $ = (id) => document.getElementById(id);
  const slotsEl = $('slots'), texEl = $('textures');

  function drawTexIcon(canvas, id) {
    // simple glyph of each texture, drawn so the picker reads before the models load
    const c = canvas.getContext('2d'); const w = canvas.width = 120, h = canvas.height = 120;
    const ink = getComputedStyle(document.documentElement).getPropertyValue('--muted').trim() || '#6B4A43';
    c.clearRect(0, 0, w, h); c.strokeStyle = ink; c.fillStyle = ink; c.lineWidth = 2.2;
    const x0 = 42, x1 = 78;
    if (id === 1) { for (let k = 0; k < 3; k++) { c.beginPath(); c.ellipse(60, 30 + k * 28, 20, 14, 0, 0, 7); c.stroke(); for (let j = -2; j <= 2; j++) { c.beginPath(); c.moveTo(60 + j * 6, 18 + k * 28); c.lineTo(60 + j * 6, 42 + k * 28); c.stroke(); } } }
    if (id === 2) { c.strokeRect(x0, 14, x1 - x0, 92); for (let y = 22; y < 104; y += 10) for (let x = x0 + 6 + ((y / 10) % 2) * 5; x < x1 - 2; x += 10) { c.beginPath(); c.arc(x, y, 3, 0, 7); c.fill(); } }
    if (id === 3) { c.strokeRect(x0, 14, x1 - x0, 92); for (let x = x0 + 6; x < x1; x += 6) { c.beginPath(); c.moveTo(x, 14); c.lineTo(x, 106); c.stroke(); } }
    if (id === 4) { c.save(); c.beginPath(); c.rect(x0, 14, x1 - x0, 92); c.stroke(); c.clip(); for (let k = -10; k < 14; k++) { c.beginPath(); c.moveTo(x0, 14 + k * 9); c.lineTo(x1, 14 + k * 9 + 26); c.stroke(); } c.restore(); }
    if (id === 5) { c.strokeRect(x0, 14, x1 - x0, 92); for (let y = 14; y < 106; y += 9) for (let x = x0; x < x1; x += 9) { c.beginPath(); c.moveTo(x, y); c.lineTo(x + 9, y + 9); c.moveTo(x + 9, y); c.lineTo(x, y + 9); c.stroke(); } }
    if (id === 6) { c.strokeRect(x0, 14, x1 - x0, 92); for (let y = 14; y < 106; y += 15) { c.beginPath(); c.moveTo(x0, y); c.lineTo(x1, y); c.stroke(); for (let x = x0; x < x1; x += 12) { c.beginPath(); c.moveTo(x + 6, y); c.lineTo(x + 3, y + 15); c.moveTo(x + 6, y); c.lineTo(x + 9, y + 15); c.stroke(); } } }
  }

  SLOT_NAMES.forEach((i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'slot'; b.id = `slot-${i}`;
    b.innerHTML = `<span class="num"></span><span class="tex"></span><span class="dot"></span>`;
    b.addEventListener('click', (e) => (e.shiftKey || e.metaKey || e.ctrlKey ? toggleSlot(i) : selectOnly([i])));
    slotsEl.append(b);
  });
  TEXTURES.forEach((t) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'tex-btn'; b.id = `tex-${t.id}`; b.setAttribute('role', 'radio');
    b.innerHTML = `<canvas aria-hidden="true"></canvas><b>${t.name}</b><span>${t.desc}</span>`;
    drawTexIcon(b.querySelector('canvas'), t.id);
    b.addEventListener('click', () => setTexture(t.id));
    texEl.append(b);
  });
  function makeSwatches(el, onPick, id) {
    COLORS.forEach((c, ci) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'sw'; b.id = `${id}-${ci}`; b.title = c.name; b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.name); b.style.setProperty('--c', c.hex); b.innerHTML = '<i></i>';
      b.addEventListener('click', () => onPick(ci));
      el.append(b);
    });
  }
  // remember which color was picked last, so "All one color" can follow it
  let lastPick = null;
  makeSwatches($('hold-cols'), (ci) => { lastPick = ci; state.selected.forEach((i) => (state.col[i] = ci)); render(); }, 'hc');
  makeSwatches($('base-cols'), (ci) => { lastPick = ci; state.base = ci; render(); }, 'bc');

  // per-holder color dropdowns, always available whatever is selected
  SLOT_NAMES.forEach((i) => {
    const row = document.createElement('label');
    row.className = 'each-row'; row.id = `each-${i}`;
    row.innerHTML = `<span class="k"></span><span class="dot"></span><select>${COLORS.map((c, ci) => `<option value="${ci}">${c.name}</option>`).join('')}</select>`;
    row.querySelector('select').addEventListener('change', (e) => { state.col[i] = +e.target.value; selectOnly([i]); });
    $('each-list').append(row);
  });

  function selectOnly(list) { state.selected = new Set(list); render(); }
  function toggleSlot(i) {
    if (state.selected.has(i) && state.selected.size > 1) state.selected.delete(i); else state.selected.add(i);
    render();
  }
  function setTexture(id) {
    state.selected.forEach((i) => { state.tex[i] = id; applyTexture(i); });
    render();
  }
  $('sel-all').onclick = () => selectOnly([0, 1, 2, 3, 4, 5, 6, 7, 8]);
  $('sel-eight').onclick = () => selectOnly(SLOT_NAMES.filter((i) => !isSham(i)));
  $('sel-sham').onclick = () => selectOnly([state.sham]);
  function moveShamash(pos) {
    const old = state.sham;
    if (pos === old) return;
    // the shamash keeps its look when it moves; the holder it swaps with takes the old spot
    [state.tex[old], state.tex[pos]] = [state.tex[pos], state.tex[old]];
    [state.col[old], state.col[pos]] = [state.col[pos], state.col[old]];
    state.sham = pos;
    applyTexture(old); applyTexture(pos);
    selectOnly([pos]);
  }
  document.querySelectorAll('#sham-pos [data-pos]').forEach((b) => b.addEventListener('click', () => moveShamash(+b.dataset.pos)));
  // color mixes: index into COLORS, left to right
  const setCols = (cols) => { state.col = cols.slice(); selectOnly(SLOT_NAMES); };
  const firstCol = () => state.col[state.sham === 0 ? 1 : 0];
  const contrast = (ci) => (COLORS[ci].hex > '#999999' ? 9 : 0); // light picks terracotta, dark picks bone white
  // all one color takes the base along with it
  $('c-one').onclick = () => { state.base = lastPick ?? firstCol(); setCols(Array(9).fill(state.base)); };
  $('c-sham').onclick = () => { const a = firstCol(), b = contrast(a); setCols(SLOT_NAMES.map((i) => (isSham(i) ? b : a))); };
  // alternate two or three colors across all nine holders, each one picked from a dropdown
  const calt = [0, 9, 6];
  function applyCalt() {
    const n = $('calt-picks').children.length;
    const cols = SLOT_NAMES.map((i) => calt[i % n]);
    state.base = cols[state.sham]; // base matches the shamash
    setCols(cols);
  }
  function showCalt(n) {
    const box = $('calt-picks');
    box.innerHTML = '';
    for (let j = 0; j < n; j++) {
      const sel = document.createElement('select');
      sel.setAttribute('aria-label', `Color ${j + 1}`);
      sel.innerHTML = COLORS.map((c, ci) => `<option value="${ci}">${c.name}</option>`).join('');
      sel.value = calt[j];
      sel.addEventListener('change', () => { calt[j] = +sel.value; applyCalt(); });
      box.append(sel);
    }
    $('calt').hidden = false;
    $('c-alt2').setAttribute('aria-pressed', n === 2 ? 'true' : 'false');
    $('c-alt3').setAttribute('aria-pressed', n === 3 ? 'true' : 'false');
    applyCalt();
  }
  const hideCalt = () => { $('calt').hidden = true; $('c-alt2').setAttribute('aria-pressed', 'false'); $('c-alt3').setAttribute('aria-pressed', 'false'); };
  $('c-alt2').onclick = () => showCalt(2);
  $('c-alt3').onclick = () => showCalt(3);
  ['c-one', 'c-sham', 'c-mix'].forEach((id) => $(id).addEventListener('click', hideCalt));
  $('c-mix').onclick = () => setCols([9, 0, 5, 3, 6, 2, 4, 1, 7]);
  // shamash in Object 04, then the eight holders left to right: 01-06, then 01 and 02 again
  $('p-mix').addEventListener('click', () => { $('alt').hidden = true; $('p-alt2').setAttribute('aria-pressed', 'false'); $('p-alt3').setAttribute('aria-pressed', 'false'); });
  $('p-mix').onclick = () => { const order = [1, 2, 3, 4, 5, 6, 1, 2]; let k = 0; state.tex = SLOT_NAMES.map((i) => (isSham(i) ? 4 : order[k++])); state.tex.forEach((_, i) => applyTexture(i)); selectOnly([0, 1, 2, 3, 4, 5, 6, 7, 8]); };
  // alternate two or three textures across all nine holders (shamash included), each one picked from a dropdown
  let altPicks = [1, 2, 3];
  function applyAlt() {
    const n = $('alt-picks').children.length;
    let k = 0;
    state.tex = SLOT_NAMES.map(() => altPicks[k++ % n]);
    state.tex.forEach((_, i) => applyTexture(i));
    selectOnly(SLOT_NAMES);
  }
  function showAlt(n) {
    const box = $('alt-picks');
    box.innerHTML = '';
    for (let j = 0; j < n; j++) {
      const sel = document.createElement('select');
      sel.setAttribute('aria-label', `Texture ${j + 1}`);
      sel.innerHTML = TEXTURES.map((t) => `<option value="${t.id}">${t.name} \u00b7 ${t.desc}</option>`).join('');
      sel.value = altPicks[j];
      sel.addEventListener('change', () => { altPicks[j] = +sel.value; applyAlt(); });
      box.append(sel);
    }
    $('alt').hidden = false;
    $('p-alt2').setAttribute('aria-pressed', n === 2 ? 'true' : 'false');
    $('p-alt3').setAttribute('aria-pressed', n === 3 ? 'true' : 'false');
    applyAlt();
  }
  $('p-alt2').onclick = () => showAlt(2);
  $('p-alt3').onclick = () => showAlt(3);
  $('evening').addEventListener('change', (e) => { state.evening = e.target.checked; if (state.evening && state.night === 0) { state.night = 8; $('night').value = 8; } render(); });
  $('cups').addEventListener('change', (e) => { state.cups = e.target.checked; render(); });
  $('night').addEventListener('input', (e) => { state.night = +e.target.value; render(); });

  function render() {
    const sel = state.selected;
    $('sel-count').textContent = sel.size === 9 ? 'All 9 selected' : sel.size === 1 ? `${label([...sel][0])} selected` : `${sel.size} selected`;
    document.querySelectorAll('#sham-pos [data-pos]').forEach((b) => b.setAttribute('aria-pressed', +b.dataset.pos === state.sham ? 'true' : 'false'));
    SLOT_NAMES.forEach((i) => {
      const b = $(`slot-${i}`);
      b.classList.toggle('sham', isSham(i));
      b.querySelector('.num').textContent = isSham(i) ? 'S' : nightNo(i);
      b.setAttribute('aria-label', label(i));
      b.setAttribute('aria-pressed', sel.has(i) ? 'true' : 'false');
      b.querySelector('.tex').textContent = String(state.tex[i]).padStart(2, '0');
      b.style.setProperty('--c', COLORS[state.col[i]].hex);
    });
    const selTex = new Set([...sel].map((i) => state.tex[i]));
    TEXTURES.forEach((t) => {
      const b = $(`tex-${t.id}`);
      b.setAttribute('aria-checked', selTex.size === 1 && selTex.has(t.id) ? 'true' : 'false');
      b.classList.toggle('mixed', selTex.size > 1 && selTex.has(t.id));
    });
    const selCol = new Set([...sel].map((i) => state.col[i]));
    COLORS.forEach((c, ci) => {
      $(`hc-${ci}`).setAttribute('aria-checked', selCol.size === 1 && selCol.has(ci) ? 'true' : 'false');
      $(`bc-${ci}`).setAttribute('aria-checked', state.base === ci ? 'true' : 'false');
    });
    $('hold-col-for').textContent = sel.size === 9 ? 'All holders' : sel.size === 1 ? label([...sel][0]) : `${sel.size} selected holders`;
    $('hold-col-name').textContent = selCol.size === 1 ? COLORS[[...selCol][0]].name : 'Mixed';
    SLOT_NAMES.forEach((i) => {
      const row = $(`each-${i}`);
      row.querySelector('.k').textContent = label(i);
      row.querySelector('.dot').style.setProperty('--c', COLORS[state.col[i]].hex);
      row.querySelector('select').value = String(state.col[i]);
    });
    $('base-col-name').textContent = COLORS[state.base].name;
    $('night-label').textContent = state.night === 0 ? 'Unlit' : `Night ${state.night}`;
    $('summary').innerHTML = SLOT_NAMES.map((i) => {
      const t = TEXTURES[state.tex[i] - 1], c = COLORS[state.col[i]];
      return `<li><span class="k">${label(i)}</span><span>${t.name} · ${c.name}</span><span class="dot" style="--c:${c.hex}" title="${c.name}"></span></li>`;
    }).join('') + `<li><span class="k">Base</span><span>${COLORS[state.base].name}</span><span class="dot" style="--c:${COLORS[state.base].hex}"></span></li>`;
    applyColors(); applySelectionMarkers(); applyLights();
  }

  // texture picker thumbnails: render each real holder model once in a small offscreen renderer
  async function renderThumbs() {
    const tr = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    const S = 320;
    tr.setPixelRatio(1); tr.setSize(S, S, false);
    tr.outputEncoding = THREE.sRGBEncoding;
    tr.toneMapping = THREE.LinearToneMapping; tr.toneMappingExposure = 0.45;
    const ts = new THREE.Scene();
    ts.environment = new THREE.PMREMGenerator(tr).fromScene(new THREE.RoomEnvironment(), 0.04).texture;
    const k = new THREE.DirectionalLight(0xfff8f0, 0.7); k.position.set(-220, 380, 420); ts.add(k);
    ts.add(new THREE.HemisphereLight(0xffffff, 0xb9b2aa, 0.35));
    const f = new THREE.DirectionalLight(0xffffff, 0.2); f.position.set(300, 120, 400); ts.add(f);
    const cam = new THREE.PerspectiveCamera(21, 1, 5, 2000);
    cam.position.set(0, 100, 185); cam.lookAt(0, 40, 0); // frames the body; the screw stays just out of view
    const mesh = new THREE.Mesh(new THREE.BufferGeometry(), mat(0));
    ts.add(mesh);
    for (const t of TEXTURES) {
      mesh.geometry = await getGeo(`o${t.id}_reg`);
      tr.render(ts, cam);
      const c = $(`tex-${t.id}`).querySelector('canvas');
      c.width = S; c.height = S;
      const g = c.getContext('2d');
      g.clearRect(0, 0, S, S);
      g.drawImage(tr.domElement, 0, 0);
    }
    tr.dispose();
  }

  /* ---------- add to cart: the whole design rides on the line item ---------- */
  function designProperties() {
    const props = { 'Shamash position': state.sham === 0 ? 'Side' : 'Center' };
    const order = [...Array(9).keys()].sort((a, b) => nightNo(a) - nightNo(b));
    for (const i of order) props[label(i)] = `${TEXTURES[state.tex[i] - 1].name} · ${COLORS[state.col[i]].name}`;
    props.Base = COLORS[state.base].name;
    props['_Layout (left to right)'] = [...Array(9).keys()].map((i) => `${label(i)}: ${String(state.tex[i]).padStart(2, '0')}/${COLORS[state.col[i]].name}`).join(', ');
    return props;
  }
  const addBtn = $('add');
  addBtn.addEventListener('click', async () => {
    addBtn.disabled = true;
    const idle = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    $('add-note').textContent = '';
    try {
      const r = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1, properties: designProperties() }] })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      if (typeof refreshCartCount === 'function') await refreshCartCount();
      if (typeof cartToast !== 'undefined') cartToast.show('Your hanukkiah was added to your cart');
      $('add-note').textContent = 'Added. Change anything and add another, or head to your cart.';
    } catch (e) {
      $('add-note').textContent = e.message;
    } finally {
      addBtn.disabled = false;
      addBtn.textContent = idle;
    }
  });

  /* ---------- 3D / Photos switch: photos come from the product's images in admin ---------- */
  const photos = $('photos');
  if (photos) {
    const track = photos.querySelector('[data-track]');
    root.querySelectorAll('[data-view]').forEach((b) => b.addEventListener('click', () => {
      const showPhotos = b.dataset.view === 'photos';
      root.querySelectorAll('[data-view]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      photos.hidden = !showPhotos;
      stage.hidden = showPhotos;
    }));
    photos.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => {
      const w = track.clientWidth, n = track.children.length;
      const i = (Math.round(track.scrollLeft / w) + Number(b.dataset.step) + n) % n;
      track.scrollTo({ left: i * w, behavior: 'smooth' });
    }));
  }

  /* ---------- phones: floating mini preview while scrolling the options ---------- */
  const mini = $('mini');
  if (mini) {
    const phone = window.matchMedia('(max-width: 900px)');
    let past = false;
    const dock = () => {
      const next = phone.matches && past && !stage.hidden ? mini : stage;
      if (next === host) return;
      host = next;
      next.prepend(renderer.domElement);
      mini.hidden = next !== mini;
      resize();
    };
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; dock(); }).observe(stage);
    new ResizeObserver(resize).observe(mini);
    phone.addEventListener('change', dock);
    root.querySelectorAll('[data-view]').forEach((b) => b.addEventListener('click', dock));
    $('mini-up').addEventListener('click', () => stage.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }

  const baseReady = getGeo('base').then((geo) => { base.geometry = geo; });
  Promise.all([baseReady, ...holders.map((_, i) => applyTexture(i))]).then(() => { $('loading').hidden = true; return renderThumbs(); })
    .catch(() => { $('loading').textContent = 'The 3D models could not load. Refresh to try again.'; });
  render();
})();
